<template>
    <div>
        <v-simple-table v-for="comDiff in diff.diffs">
            <tr>
                <td v-if="comDiff.old !== null" width="45%">
                    <div class="d-flex flex-column" v-if="comDiff.new!== null">
                        <small>Ancien</small>
                        <span class="p-2">{{ comDiff.old }}</span>
                    </div>
                    <div class="d-flex flex-column" v-else>
                        <small style="color: #F44336">Supprimé</small>
                        <span class="p-2"
                              :style="'background-color:' + deleteColors.light + '; color:' + deleteColors.deep">
                            {{ comDiff.old }}
                        </span>
                    </div>
                </td>

                <td v-else width="45%"></td>

                <td v-if="comDiff.new !== null" width="45%">
                    <div class="d-flex flex-column">
                        <small :style="'color:' + getInputClass(comDiff).deep">Nouveau</small>
                        <span :style="'background-color:' + getInputClass(comDiff).light +
                        '; color:' + getInputClass(comDiff).deep"
                              class="p-2">
                        {{ comDiff.new }}
                    </span>
                    </div>
                </td>
                <td v-else width="45%"></td>
            </tr>
        </v-simple-table>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "comDiffsVt",
    props: ["diff"],
    methods: {
        getInputClass(diff) {
            if (diff.new !== null && diff.old === null) {
                return this.addColors
            } else if (diff.new !== null && diff.old !== null) {
                return this.updateColors
            } else if (diff.new === null && diff.old !== null) {
                return this.deleteColors
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>